import { withDot } from '#/common/utils/wrappers';

export type DotItem = {
  value: string;
  text: string;
  color: string;
};

const dotTemplate = (item: DotItem) => {
  return withDot(item?.text || item?.value, item?.color);
};

export default dotTemplate;
